import laptopImage from 'images/three_d_studio/mocked_model/laptop.webp'

export const mockedModel = {
  id: 1,
  attributes: {
    "mainRun": {
      "prompt": "a computer",
      "createdAt": "2026-03-04T15:34:27.480Z",
      "variationsCount": 3,
      "outputAssets": [
        {
          "previewUrl": laptopImage,
        },
      ],
    },
  },
}
